import React from "react";
import { ErrorCardNewStyle } from "./ErrorCardNew.styles";
import { Dangerous } from "@src/Assets/svg/Dangerous";
import { Rule } from "@src/Assets/svg/Rule";
import { metricCardErrorStore } from "@src/store/store";
import { ERROR_Text, MUltiple_TaxID_Error, Secure_Justification_Error, MUltiple_TaxID_Warning, FALLBACK_API_ERROR, MAX_TINS_LIMIT } from "./constant";

export const ErrorCardNew = ({ taxIdLink = false, secureFlag = false, errorType= '', fallbackWidth=false }) => {

    const { errorMessage } = metricCardErrorStore((state: { errorMessage: any, infoMessage: string, setErrorMessage: Function, setInfoMessage: Function }) => ({
        errorMessage: state.errorMessage,
        infoMessage: state.infoMessage,
        setErrorMessage: state.setErrorMessage,
        setInfoMessage: state.setInfoMessage,
    }));

    // Normalize errorType to ensure it's always a string
    const normalizedErrorType = errorType ? errorType.toLowerCase() : '';

    const getFormattedErrorMessage = () => {
        let strArr = errorMessage.Message.split(',');
        let finalStr;
        if (errorMessage.TypeOfError === 0) {
            if (strArr.length === 1) {
                finalStr = (<><span className="bold-message">Some Data Not Found. </span> <span className="message">Based on your filters, </span><span className="bold-message">{errorMessage.Message}
                </span> <span className="message">has been suppressed.</span></>);
            }
            else if (strArr.length > 2) {
                let lastStr = strArr.pop();
                finalStr = (<><span className="bold-message">Some Data Not Found. </span> <span className="message">Based on your filters, </span><span className="bold-message">{strArr.toString().split(',').join(', ')} and {lastStr}
                </span> <span className="message">have been suppressed.</span></>);
            } else {

                strArr = strArr.toString().split(',').join(' and ');
                finalStr = (<><span className="bold-message">Some Data Not Found. </span> <span className="message">Based on your filters, </span><span className="bold-message">{strArr}
                </span> <span className="message">have been suppressed.</span></>);
            }
        } else {
            let lastStr = strArr.pop();
            finalStr = (<><span className="bold-message">Some Data Not Found. </span> <span className="message">Based on your filters, </span><span className="bold-message">{strArr.toString()} and {lastStr}
            </span> <span className="message">have been suppressed.</span></>);
        }
        return finalStr;

    }
    return (<ErrorCardNewStyle>
        {!taxIdLink ?   errorMessage.Message && <div className="container">
            {errorMessage && errorMessage.TypeOfError === 500 && <div className="info-message">
                <div>
                    <Dangerous />
                    <div className="message-text">
                        {getFormattedErrorMessage()}
                    </div>
                </div>
            </div>}

            {/* {errorMessage && errorMessage.TypeOfError !== 0 && (
                <hr className="grey-line" />
            )} */}
            {errorMessage && errorMessage.TypeOfError === 0 && <div className="info-message">
                <Rule />
                <div className="message-text">
                    {getFormattedErrorMessage()}
                </div>
            </div>
            }

        </div> : 
            
               normalizedErrorType !== 'warning' ? (<div className={fallbackWidth ? "tax-info-message-fallback" : "tax-info-message"}>
                <div className='error-icon-tax'>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.75 20C6.4537 20 6.1713 19.9444 5.90278 19.8333C5.63426 19.7222 5.39815 19.5648 5.19445 19.3611L0.638889 14.8056C0.435185 14.6019 0.277778 14.3657 0.166667 14.0972C0.0555556 13.8287 0 13.5463 0 13.25V6.75C0 6.4537 0.0555556 6.1713 0.166667 5.90278C0.277778 5.63426 0.435185 5.39815 0.638889 5.19445L5.19445 0.638889C5.39815 0.435185 5.63426 0.277778 5.90278 0.166667C6.1713 0.0555556 6.4537 0 6.75 0H13.25C13.5463 0 13.8287 0.0555556 14.0972 0.166667C14.3657 0.277778 14.6019 0.435185 14.8056 0.638889L19.3611 5.19445C19.5648 5.39815 19.7222 5.63426 19.8333 5.90278C19.9444 6.1713 20 6.4537 20 6.75V13.25C20 13.5463 19.9444 13.8287 19.8333 14.0972C19.7222 14.3657 19.5648 14.6019 19.3611 14.8056L14.8056 19.3611C14.6019 19.5648 14.3657 19.7222 14.0972 19.8333C13.8287 19.9444 13.5463 20 13.25 20H6.75ZM10 11.5556L12.3889 13.9444C12.5926 14.1481 12.8519 14.25 13.1667 14.25C13.4815 14.25 13.7407 14.1481 13.9444 13.9444C14.1481 13.7407 14.25 13.4815 14.25 13.1667C14.25 12.8519 14.1481 12.5926 13.9444 12.3889L11.5556 10L13.9444 7.61111C14.1481 7.40741 14.25 7.14815 14.25 6.83333C14.25 6.51852 14.1481 6.25926 13.9444 6.05556C13.7407 5.85185 13.4815 5.75 13.1667 5.75C12.8519 5.75 12.5926 5.85185 12.3889 6.05556L10 8.44444L7.61111 6.05556C7.40741 5.85185 7.14815 5.75 6.83333 5.75C6.51852 5.75 6.25926 5.85185 6.05556 6.05556C5.85185 6.25926 5.75 6.51852 5.75 6.83333C5.75 7.14815 5.85185 7.40741 6.05556 7.61111L8.44444 10L6.05556 12.3889C5.85185 12.5926 5.75 12.8519 5.75 13.1667C5.75 13.4815 5.85185 13.7407 6.05556 13.9444C6.25926 14.1481 6.51852 14.25 6.83333 14.25C7.14815 14.25 7.40741 14.1481 7.61111 13.9444L10 11.5556Z" fill="#C40000" />
                    </svg>

                </div>
                <div className="message-text-tax">
                    <div className="error-tax">
                        {`${ERROR_Text}`}
                    </div>
                    <div className="message-tax">
                        {!secureFlag ? normalizedErrorType === 'limit_error' ? MAX_TINS_LIMIT : MUltiple_TaxID_Error : fallbackWidth ? FALLBACK_API_ERROR : Secure_Justification_Error}
                    </div>
                </div>
            </div>) :  (<div className={fallbackWidth ? "tax-info-message-fallback" : "tax-info-message"}><div className='error-icon-tax'>
                    <Rule />
                    </div><div className="message-text-tax">
                            <div className="message-tax">
                                {!secureFlag ? MUltiple_TaxID_Warning : fallbackWidth ? FALLBACK_API_ERROR : Secure_Justification_Error}
                            </div>
                        </div></div>)  
        }

    </ErrorCardNewStyle >)
}